import { AccommodationCreateSource, GetAccommodationResponse } from '@orbit/api-types'
import { getDeviceContext } from '@lib/analytics'
import api from '@lib/api'
import { queryKeys } from '@lib/queryKeys'
import { createTripMutation } from './createTripCrudResource'

export interface CreateAccommodationPayload {
    name: string
    checkInDate: string
    checkOutDate: string
    guestUserIds: number[]
    notes?: string | null
    links?: string[]
    location?: {
        fullText: string
        primaryText?: string | null
        secondaryText?: string | null
        googlePlaceId?: string | null
        googleTypes?: string[]
    } | null
    /** Where the Accommodation was started, which the server records it with. */
    source?: AccommodationCreateSource
}

export const useCreateAccommodation = createTripMutation<
    GetAccommodationResponse,
    { tripId: string; accommodationData: CreateAccommodationPayload }
>({
    mutationFn: async ({ tripId, accommodationData }) => {
        const response = await api.post<GetAccommodationResponse>(`/trips/${tripId}/accommodations`, { ...accommodationData, analytics: getDeviceContext() })
        return response.data
    },
    invalidate: ({ tripId }) => [queryKeys.accommodations(tripId)],
})
